<template>
  <div class="bg-light section-container p-t-20">
    <div class="container to-resp ">
      <div class="account-container" style="min-height: 600px;">
        <div class="account-sidebar">
          <div class="account-sidebar-cover">
            <!-- img src="../../assets/color-theme/img/cover/cover-3.jpg" alt="" -->
          </div>
          <div class="account-sidebar-content">
            <h4>Personal Account</h4>
            <!-- Profile menu -->
            <ul class="nav nav-list">
              <li> 
                <router-link class="nav-link hover-orange" :to="{ name: 'Profile'}">My profile</router-link>
              </li>
              <li>
                <router-link class="nav-link hover-orange" :to="{ name: 'EditProfile'}">Edit profile</router-link>
              </li>
              <li>
                <router-link class="nav-link hover-orange" :to="{ name: 'EditPasswordProfile'}">Change password</router-link>
              </li>
              <li>
                <router-link class="nav-link hover-orange" :to="{ name: 'MyPurchases'}">My requests</router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="account-body">
          <router-view class="p-l-40 p-r-40"></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Profile'
}
</script>
<style>
.account-container .account-sidebar {
  width: 300px;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  padding: 20px 30px;
  overflow: hidden;
  -webkit-border-radius: 6px 0 0 6px;
  -moz-border-radius: 6px 0 0 6px;
  border-radius: 6px 0 0 6px;
  background-color: #24272a;
}
.account-container .account-sidebar .account-sidebar-cover {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.account-container {
  background: #fff;
  border-radius: 6px;
  position: relative;
}
.account-container .account-sidebar .account-sidebar-cover:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(36, 42, 48, 0.8);
}
.account-container .account-sidebar .account-sidebar-content {
  position: relative;
  color: #fff;
}
.nav {
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.account-sidebar li a {
  color: #fff;
}

.nav-link {
  cursor: pointer;
}
.account-container .account-body {
  margin-left: 300px;
  padding: 20px 30px;
}
.p-l-40 {
  padding-left: 40px !important;
}
.p-r-40 {
  padding-right: 40px !important;
}

.btn-group-vertical > .btn-group:after,
.btn-group-vertical > .btn-group:before,
.btn-toolbar:after,
.btn-toolbar:before,
.clearfix:after,
.clearfix:before,
.container-fluid:after,
.container-fluid:before,
.container:after,
.container:before,
.dl-horizontal dd:after,
.dl-horizontal dd:before,
.form-horizontal .form-group:after,
.form-horizontal .form-group:before,
.modal-footer:after,
.modal-footer:before,
.modal-header:after,
.modal-header:before,
.nav:after,
.nav:before,
.navbar-collapse:after,
.navbar-collapse:before,
.navbar-header:after,
.navbar-header:before,
.navbar:after,
.navbar:before,
.pager:after,
.pager:before,
.panel-body:after,
.panel-body:before,
.row:after,
.row:before {
  display: table;
  content: " ";
}
.p-t-20 {
    padding-top: 20px!important;
}

.section-container {
    padding: 45px 0;
}
@media (max-width: 461px) {
  .container .to-resp{
    display: flex !important;;
  }
  .account-body{
    display: flex;
  }
}
.hover-orange:hover, .hover-orange :focus {
  color:#E95913!important ;
}
.account-sidebar li a:hover, .account-sidebar li a:focus {
  color:#E95913!important ;
}
</style>
<style scoped>
.nav > li > a {
  padding: 10px 15px;
}
.nav > li,
.nav > li > a {
  position: relative;
  display: block;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/pages/profile/ProfileLayout.vue